<template>
<div class="chapter">
<div class="inner_page">
<p class="image"><img alt="images" src="images/f015-01.jpg" width="80%"/></p>
<p class="caption"><em class="italic">Sir Douglas Haig</em>.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 20_fm033.vue?8cedfc2e